import classNames from "classnames";
import {
    IoMdDesktop,
    IoIosBriefcase,
    IoIosChatbubbles,
    IoMdHeart,
    IoMdPin,
    IoIosRocket,
    IoMdTrophy,
} from "react-icons/io";
import {person} from "../../store/person";
import React from "react";
import {Card} from "./card";

// Renders **bold** markers as <strong> and \n as <br />.
const bold = (text: string): React.ReactNode[] =>
    text.split(/\*\*(.*?)\*\*/g).flatMap((part, i) => {
        if (i % 2 === 1) return [<strong key={`b${i}`}>{part}</strong>];
        return part.split('\n').flatMap((line, j, arr) =>
            j < arr.length - 1 ? [line, <br key={`br${i}-${j}`} />] : [line]
        );
    });

interface Props {}

export const Aboutcards = (props: Props) => (
    <div className={classNames({"contentWrapper":true, "aboutCards":true})}>
        <Card>
            <IoMdPin />
            <label>Based in</label>
            <p>
                <strong>{person.city}</strong>{(person.locationHint) ? " " + person.locationHint : null},<br/>
                {person.state}, <br/>
                {person.country}
            </p>
        </Card>
        <Card>
            <IoIosBriefcase />
            <label>Currently Working at</label>
            <p>
                {person.preferredIdes.map((ide,i) => {
                    const last = i+1 ===  person.preferredIdes.length;
                    return (<text key={i}>{bold(ide)}{(!last) ? (<text>, <br /></text>) : null}</text>)
                })}
            </p>
        </Card>
        <Card>
            <IoIosChatbubbles />
            <label>Language</label>
            <p>
                {person.favTec.map((tec,i) => {
                    const last = i+1 ===  person.favTec.length;
                    return (<text>{tec}{(!last) ? (<text>, <br /></text>) : null}</text>)
                })}
            </p>
        </Card>
        <Card>
            <IoIosRocket />
            <label>Qualities</label>
            <p>
                {person.programs.map((program,i) => {
                    const last = i+1 ===  person.programs.length;
                    return (<text key={i}>{bold(program)}{(!last) ? (<text>, <br /></text>) : null}</text>)
                })}
            </p>
        </Card>
        <Card>
            <IoMdDesktop />
            <label>Technologies</label>
            <p>
                {person.operatingSystems.map((os,i) => {
                    const last = i+1 ===  person.operatingSystems.length;
                    return (<text>{os}{(!last) ? (<text>, <br /></text>) : null}</text>)
                })}
            </p>
        </Card>
        <Card>
            <IoMdHeart />
            <label>Interests</label>
            <p>
                {person.interests.map((interest,i) => {
                    const last = i+1 ===  person.interests.length;
                    return (<text>{interest}{(!last) ? (<text>, <br /></text>) : null}</text>)
                })}
            </p>
        </Card>
        <Card className="card--award">
            <IoMdTrophy />
            <label>Awards &amp; Scholarships</label>
            <p>
                {person.awards.map((award, i) => {
                    const last = i + 1 === person.awards.length;
                    return (<text key={i}>{bold(award)}{(!last) ? (<text>, <br /></text>) : null}</text>)
                })}
            </p>
        </Card>
    </div>
);

export default Aboutcards;